import { TextCaption, TooltipBubble } from '@carboncopyco/ui';
import { CloseIcon } from '../../../../../assets/svg/CloseIcon';
import { tooltipHackClasses } from '../../../constants';
import InnerTabHover from './InnerTabHover';
import type { AppInnerTabsItem } from './types';
import { getCloseIconClasses } from './utils';

interface InnerTabProps {
  tab: AppInnerTabsItem;
  activeTabId: AppInnerTabsItem['id'];
  onClick: (tabId: number) => void;
  onClose: (tabId: number) => void;
}

const InnerTab = ({ tab, activeTabId, onClick, onClose }: InnerTabProps) => {
  const isActiveTab = tab.id === activeTabId;

  return (
    <button
      type="button"
      onClick={() => onClick(tab.id)}
      className={`group flex items-center justify-between px-3 outline-none justify-between w-[200px] min-w-0 relative group ${
        isActiveTab ? '' : '!bg-[var(--ds-inner-tab-inactive-bg)]'
      }`}
      data-testid="inner-tab"
    >
      <InnerTabHover isActiveTab={isActiveTab} />
      <span className={`flex min-w-0 grow relative ${tooltipHackClasses}`}>
        <TooltipBubble
          title={tab.hoverTitle || tab.title}
          placement="top"
        >
          <TextCaption
            label={tab.title}
            color="text-ds-black"
            ellipsis
          />
        </TooltipBubble>
        <span
          className={`shrink-0 opacity-0 group-hover:opacity-100 cursor-pointer [&>svg]:text-current [&>svg]:fill-transparent [&>svg]:transition-[fill] ${getCloseIconClasses(
            isActiveTab
          )}`}
          onClick={(e) => {
            e.stopPropagation();
            onClose(tab.id);
          }}
          data-testid="inner-tab-close"
        >
          <CloseIcon />
        </span>
      </span>
    </button>
  );
};

export default InnerTab;
